import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from 'src/app/shared/contexts/asyncData';

import { getPetitionEditPageData } from './api/getPetitionEditPageData';

export const {
	Context: PetitionEditPageDataContext,
	Provider: PetitionEditPageDataContextProvider,
	useContext: usePetitionEditPageData,
	useAsyncData: usePetitionEditPageDataFromApi,
	prefetchAsyncData: prefetchPetitionEditPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'PetitionEditPageDataContext',
	dataProperty: 'pageData',
	getData: getPetitionEditPageData,
	hookDeps: ({ slugOrId, includeUndiscoverableTags }) => [slugOrId, includeUndiscoverableTags],
	getUniqueId: ({ slugOrId }) => slugOrId,
	errorHandler: pageDataErrorHandler(),
});
